import { render, staticRenderFns } from "./ShareBackupYN.vue?vue&type=template&id=2bdc7829"
import script from "./ShareBackupYN.vue?vue&type=script&lang=js"
export * from "./ShareBackupYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports